import { render, staticRenderFns } from "./AllSchoolPostCreate.vue?vue&type=template&id=9de0125a&scoped=true"
import script from "./AllSchoolPostCreate.vue?vue&type=script&lang=js"
export * from "./AllSchoolPostCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de0125a",
  null
  
)

export default component.exports